module.exports = __webpack_public_path__ + "img/05.7b19670a.png";